import { DateFormatPreference } from "./DateFormatPreference"

export enum InputDateFormat {
  DayMonthYear = "DD.MM.YYYY",
  MonthDayYear = "MM.DD.YYYY",
}

export const getInputDateFormat = (dateFormat: DateFormatPreference): InputDateFormat | undefined => {
  switch (dateFormat) {
    case DateFormatPreference.DayMonthYear:
      return InputDateFormat.DayMonthYear
    case DateFormatPreference.MonthDayYear:
      return InputDateFormat.MonthDayYear
    default:
      return
  }
}
